export function resolveCurrentLocale() {
  return localStorage.getItem("i18n.locale");
}
